module.exports = __webpack_public_path__ + "static/media/duringAudio.c5fe67b2.wav";